/* ============
 * Vue Meta
 * ============
 *
 * Plugin that allows you to manage your app's meta information
 *
 * https://github.com/declandewet/vue-meta
 */

import Vue from 'vue'
import Meta from 'vue-meta'

Vue.use(Meta)



// WEBPACK FOOTER //
// ./src/app/plugins/vue-meta.js